export const agentBuild = typeof __PLY_BUILD_INFO__ === 'undefined'
    ? { package_version: 'development', commit: 'unknown', renderer_build_id: 'unbundled' }
    : __PLY_BUILD_INFO__;
